import { createContext } from "react";

const ForexListingDataContext = createContext({});

export default ForexListingDataContext;
